<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <div class="row mb-3">
      <div class="col-12">
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/ingredients/add'"
          >Add Ingredient</b-btn
        >
      </div>
    </div>

    <b-row class="mt-3">
      <b-col md="12">
        <b-table :items="ingredients" :fields="fields" v-if="ingredients">
<!--            <template slot="cell(coa)" slot-scope="row">-->
<!--                <ul>-->
<!--                    <img :src="'/assets/icons/tick.png'" v-if="row.item.tracking_number"/>-->
<!--                </ul>-->
<!--            </template>-->
          <template slot="cell(stock)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.stock">
                {{
                  item.quantity + " X " + item.model + " (" + item.name + ")"
                }}
              </li>
            </ul>
          </template>
          <template slot="cell(actions)" slot-scope="row">
            <div style="width:300px;" v-if="row.item.status_id != 3">
              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                :to="'/ingredients/' + row.item.ingredient_id + '/edit/'"
                >Edit</b-button
              >
              <b-button
                size="sm"
                variant="danger"
                class="ml-2"
                @click="deleteConfirm(row.item.ingredient_id)"
                >Delete</b-button
              >
            </div>
            <div style="width:300px;" v-if="row.item.status_id == 3">
              Ingredient Complete - No action required
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="!ingredients || ingredients.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No ingredients yet!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ingredients",
  components: {},
  data() {
    return {
      ingredients: null,
      fields: [
        { key: "ingredient_id", label: "#", sortable: true },
        { key: "name", label: "Name" },
        // { key: "coa", label: "COA" },
        { key: "alternative_name", label: "Alternative Name" },
        { key: "cas_number", label: "CAS Number" },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Ingredients", active: true }
      ]
    };
  },
  mounted: function() {
    this.getIngredients();
  },
  methods: {
    getIngredients: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/ingredients").then(
        response => {
          this.ingredients = response.data.ingredients;

          // console.log(this.ingredients);

          loader.hide();
        },
        error => {
          loader.hide();

          // console.log(error);
        }
      );
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete ingredient: " + id,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deleteIngredient(id);
        }
      });
    },
    deleteIngredient(id) {
      let loader = this.$loading.show();
      this.$http.delete(this.APIURL + this.BRAND + "/ingredients/" + id).then(
        () => {
          this.$swal({
            title: "Success!",
            showConfirmButton: false,
            timer: 1000,
            html: "Ingredient deleted successfully!",
            type: "success",
            onClose: () => {
              loader.hide();
              this.getIngredients();
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    },
  }
};
</script>
